import { HomeButton } from '~/shared/layouts/components/HeaderTop/components/HomeButton'
import { Logo } from '~/shared/layouts/components/HeaderTop/Logo'

const MinimalTopbar = (): React.ReactElement => {
  return (
    <header className="z-header hidden lg:block h-16 drop-shadow-navbar bg-purple-abyss border-0 border-b border-solid border-purple-lilac-fade">
      <div className="flex items-center gap-6 px-8 h-full">
        <Logo className="w-34" white />
        <HomeButton />
      </div>
    </header>
  )
}

export default MinimalTopbar
